export default {"src":"/_next/static/media/check.a7b76ff0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};